import { Container } from "react-bootstrap";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthForm, ModalMessage } from "../../components";
import { loginApi } from "../../api/authApi";
import { setUser } from "../../redux/userSlice.js";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { updateStorageUser } from "../../utilities";
import {
  moveCartSessionToLocal,
  setStorageToken,
} from "../../utilities/storageManager";

export default function Login() {
  // Login Form with validation (formik + Yup libraries)
  // form validation schema (with Yup)
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Please enter your email"),
    password: Yup.string().required("Please enter a valid password"),
    keepSignedIn: Yup.boolean().default(false),
  });

  const formFields = [
    { name: "email", label: "Email", type: "email" },
    { name: "password", label: "Password", type: "password" },
  ];

  const [errorMsg, setErrorMsg] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // read email from register page (if redirected from there)
  const { state } = useLocation();
  const email = state && state.email;
  const nextPageLink = state && state.data;

  const initialValues = {
    email: email || "",
    password: "",
    stayLoggedIn: false,
  };

  const handleFormSubmission = async (formData) => {
    //API call
    // formData = {email:(String), password:(String), stayLoggedIn:(Boolean)}
    const abortController = new AbortController();
    try {
      const { email, password, stayLoggedIn } = formData;
      const res = await loginApi(
        {
          email,
          password,
          stayLoggedIn: stayLoggedIn || false,
        },
        abortController.signal
      );
      dispatch(setUser(res.user));
      // save token + user info to local or session storage, based on choice for 'stayLoggedIn'
      setStorageToken(res.token, stayLoggedIn);
      updateStorageUser(res.user, stayLoggedIn);
      if (stayLoggedIn) {
        moveCartSessionToLocal(stayLoggedIn); //if choose stay logged in, move cart from session (default) to local storage
      }
      if (res.user.isAdmin) {
        navigate("/admin", { replace: true }); //redirect to admin's orders page, reset history
      } else {
        navigate(nextPageLink || "/user", { replace: true }); // redirect to profile page or to nextPageLink if provided
      }
    } catch (error) {
      setErrorMsg(`${error.message}`);
    }
  };

  return (
    <Container>
      {errorMsg && (
        <ModalMessage
          type="danger"
          message={errorMsg}
          setErrorMsg={setErrorMsg}
        />
      )}
      <AuthForm
        login={true}
        validationSchema={validationSchema}
        initialValues={{...initialValues}}
        handleFormSubmission={handleFormSubmission}
        formFields={formFields}
      />
    </Container>
  );
}
